// The HTML of the tooltip card of every chart Component. The anatomy is the PointerTooltip card:
// white, rounded, a shadow and a thin ring. The value leads (bold, dark) and the label follows (gray).
// A short line keys a line series; a small square keys a bar or a band.
// Each label is escaped: a label can come from data.
import { CHART_COLORS, CHART_MARKS } from './chartTokens';

const ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' };
export const escapeHtml = (text: string): string => text.replace(/[&<>"']/g, c => ESCAPES[c]);

export const lineKey = (color: string): string =>
	`<span aria-hidden="true" class="inline-block h-0.5 w-3 rounded-full align-middle" style="background:${color}"></span>`;

// A dashed line series: two dashes of the colour.
export const dashedLineKey = (color: string): string =>
	`<span aria-hidden="true" class="inline-block h-0.5 w-3 align-middle" style="background:repeating-linear-gradient(90deg,${color} 0 5px,transparent 5px 7px)"></span>`;

export const squareKey = (color: string): string =>
	`<span aria-hidden="true" class="inline-block h-2.5 w-2.5 rounded-sm align-middle" style="background:${color}"></span>`;

export const bandKey = (): string =>
	`<span aria-hidden="true" class="inline-block h-2.5 w-3 rounded-sm align-middle" style="background:${CHART_COLORS.band};opacity:${CHART_MARKS.bandOpacity * 2.5}"></span>`;

export const tooltipRow = (key: string, value: string, label: string): string =>
	`<tr><td class="py-0.5 pr-2">${key}</td>` +
	`<td class="py-0.5 pr-3 text-right font-semibold tabular-nums text-gray-900">${value}</td>` +
	`<td class="py-0.5 text-gray-600">${escapeHtml(label)}</td></tr>`;

export const tooltipCard = (title: string, rows: string[]): string =>
	'<div class="w-max rounded-lg bg-white px-3 py-2 text-xs shadow-xl ring-1 ring-black ring-opacity-5">'
	+ `<p class="mb-1 font-semibold text-gray-900">${escapeHtml(title)}</p>`
	+ `<table><tbody>${rows.join('')}</tbody></table></div>`;
